import React from 'react';
import PropTypes from 'prop-types';
import DoorCharts from './components/charts/DoorCharts.jsx';
import configuration from './assets/interior_configuration.png';
import handing from './assets/interior_handing.png';
import InteriorDoorMeasures from './components/measures/InteriorDoorMeasures.jsx';
import BarnDoorMeasures from './components/measures/BarnDoorMeasures.jsx';
import LaborMaterial from './components/LaborMaterial.jsx';
import Comments from './components/Comments.jsx';
import ProjectNeeds from './components/ProjectNeeds.jsx';
import HomeDiagram from './components/HomeDiagram';
import ProductTemplate from './components/ProductTemplate';

function InteriorDoorTemplate({
  data,
  onChange,
  permitRequired,
  onPermitRequiredChange,
  onReadStart,
  onReadEnd,
  canViewPriceAdjustment,
}) {
  const {
    measures = { interior_doors: [], barn_doors: [] },
    needs = {},
    labors_materials = [],
    comments = '',
    home_diagram = {},
    product_template = {},
  } = data;

  const interior_doors = measures.interior_doors || [];
  const barn_doors = measures.barn_doors || [];

  return (
    <div>
      <h4>Interior Door Worksheet</h4>
      <DoorCharts
        configurationChart={configuration}
        handingChart={handing}
        configAlt="Interior Door Configuration Chart"
        handingAlt="Interior Door Handing Chart"
      />
      <InteriorDoorMeasures
        measures={interior_doors}
        onChange={updatedMeasures => onChange(
          { ...data, measures: { ...data.measures, interior_doors: updatedMeasures } },
        )}
      />
      <BarnDoorMeasures
        measures={barn_doors}
        onChange={updatedMeasures => onChange(
          { ...data, measures: { ...data.measures, barn_doors: updatedMeasures } },
        )}
      />
      <LaborMaterial
        labors_materials={labors_materials}
        onChange={updatedLaborsMaterials => onChange(
          { ...data, labors_materials: updatedLaborsMaterials },
        )}
        canViewPriceAdjustment={canViewPriceAdjustment}
      />
      <Comments
        comments={comments}
        onChange={updatedComments => onChange(
          { ...data, comments: updatedComments },
        )}
      />
      <ProjectNeeds
        needs={needs}
        onChange={updatedNeeds => onChange({ ...data, needs: updatedNeeds })}
        permitRequired={permitRequired}
        onPermitRequiredChange={onPermitRequiredChange}
      />
      <HomeDiagram
        home_diagram={home_diagram}
        onChange={updatedHomeDiagram => onChange(
          { ...data, home_diagram: updatedHomeDiagram },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
      <ProductTemplate
        product_template={product_template}
        onChange={updatedProductTemplate => onChange(
          { ...data, product_template: updatedProductTemplate },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
    </div>
  );
}

InteriorDoorTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
  canViewPriceAdjustment: PropTypes.bool,
};

export default InteriorDoorTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/InteriorDoorTemplate.jsx